import React from 'react'
import { Container, Spinner } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { IHomeNextStepContentProps } from './homeInterfaces/IHomeNextStepContentProps'
import { NextStepValue } from 'application/utils/type'
import { HomeStaticData } from './homeStaticData'
import BannerBrandImageSection from 'application/components/bannerBrandImageSection'

interface IHomeStateProps {
  applicationRoles: {
    isConsultant: boolean
  }
}
const NextStepContent = ({
  nextSteps,
  proposalEstimate,
  firstName,
  viewAcceptedProposal,
}: IHomeNextStepContentProps) => {
  const isConsultant = useSelector(
    (state: IHomeStateProps) =>
      state.applicationRoles && state.applicationRoles.isConsultant
  )

  const vehicleDesc =
    proposalEstimate &&
    proposalEstimate.vehicle &&
    `${proposalEstimate.vehicle.year} ${proposalEstimate.vehicle.make} ${proposalEstimate.vehicle.family}`

  const { step, link, isFetching } = nextSteps

  if (isFetching)
    return (
      <Container className="d-flex justify-content-center">
        <Spinner
          as="span"
          animation="border"
          role="status"
          aria-hidden="true"
          variant="light"
        />
      </Container>
    )

  let sectionTitle
  let sectionContent
  let showConsultantButton
  let firstButton
  let secondButton
  let id

  if (step === NextStepValue.NONE) {
    id = 'nextstepcontent.none'

    sectionTitle = HomeStaticData('NextStepNoneBannerTitleText', {
      firstName: firstName,
    })
    sectionContent = HomeStaticData('NextStepNoneBannerText', {
      vehicleDescription: vehicleDesc,
    })
    showConsultantButton = false
  }

  if (step === NextStepValue.ATO) {
    id = 'nextstepcontent.ato'
    showConsultantButton = false
    sectionTitle = `It’s time to approve your Authority to Order ${firstName}!`
    firstButton = {
      buttonName: 'Authority to Order',
      disabled: false,
      linkUrl: link,
    }

    sectionContent = HomeStaticData('NextStepATOBannerText', {
      vehicleDescription: vehicleDesc,
      firstName: firstName,
    })
    secondButton = {
      buttonName: 'View proposal',
      disabled: false,
      linkUrl: viewAcceptedProposal,
    }
  }

  if (step === NextStepValue.DEFERRED) {
    id = 'nextstepcontent.deferred'
    sectionTitle = `You’re almost there, check back in soon ${firstName}!`
    sectionContent = HomeStaticData('NextStepDeferredBannerText')
    firstButton = {
      buttonName: 'Confirm add-on insurances',
      disabled: true,
      linkUrl: link,
    }
    secondButton = {
      buttonName: 'View proposal',
      disabled: false,
      linkUrl: viewAcceptedProposal,
    }
  }

  if (step === NextStepValue.INSURANCE) {
    id = 'nextstepcontent.insurance'
    sectionTitle = `Don’t forget to complete your lease paperwork ${firstName} – if you have already, the team will touch base shortly`
    sectionContent = HomeStaticData('NextStepInsConBannerText', {
      vehicleDescription: vehicleDesc,
    })
    firstButton = {
      buttonName: 'Confirm add-on insurances',
      disabled: isConsultant,
      linkUrl: link,
    }
    secondButton = {
      buttonName: 'View proposal',
      disabled: false,
      linkUrl: viewAcceptedProposal,
    }
  }

  return (
    <BannerBrandImageSection
      id={id}
      imageText={`Congratulations ${firstName}!`}
      sectionTitle={sectionTitle}
      sectionContent={sectionContent}
      firstButton={firstButton}
      secondButton={secondButton}
      showConsultantButton={showConsultantButton}
      bannerImageName="Banner1"
    />
  )
}

export default NextStepContent
